import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { cartPaidLineCount } from '@theme/utilities';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   * The number matches the cart-bubble badge — paid cart lines, not units.
   * @param {CustomEvent<{ resource?: { items?: { original_price?: number }[] } }>} event
   */
  #onCartUpdate = (event) => {
    const cartCount = cartPaidLineCount(event.detail.resource);
    if (cartCount === undefined) return;

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
